import script from "./TopicOverviewActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopicOverviewActivity.vue?vue&type=script&lang=ts&setup=true"

import "./TopicOverviewActivity.vue?vue&type=style&index=0&id=b69a3ca8&lang=scss"

const __exports__ = script;

export default __exports__